<form #personForm="ngForm" *ngIf="data">
    <div class="col-xl-12">
        <h1 mat-dialog-title>{{data.title}}</h1>
        <div mat-dialog-content>
            <div>
                <mat-card>
                    <mat-card-content>
                        <figure class="card-profile-image" (click)="fileselect.click()"
                            title="{{'Click to upload an image' | translate}}">
                            <div class="imageLayer">
                                <mat-icon class="image-icon">cloud_upload</mat-icon>
                            </div>
                            <img [src]="pictureLink" loading="lazy" class="responsive-img">
                            <input [hidden]="true" type="file" name="image" accept="{{allowedAcceptExtensions}}"
                                #fileselect (change)="onBrowseFiles($event.target, 'logo')" />
                        </figure>
                        <mat-form-field *ngIf="data.handleBgColor !== undefined">
                            <input matInput type="color" name="bgcolor" [(value)]="pictureBgColor"
                                placeholder="{{'Background Color' | translate}}"
                                (change)="pictureBgColor = $event.target.value">
                        </mat-form-field>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
        <div mat-dialog-actions>
            <button color="danger" mat-raised-button (click)="closeModal(undefined)">{{'Close' | translate}}</button>
            <button *ngIf="data.data._id" mat-raised-button (click)="fileselect.click()" [disabled]="loading">{{'Upload'
                | translate}}</button>
            <button *ngIf="data.data._id && data.targetDeleteApi" mat-raised-button
                (click)="deleteFile(data.targetDeleteApi)" [disabled]="loading">{{'Clear' | translate}}</button>
            <button *ngIf="data.handleBgColor !== undefined" mat-raised-button (click)="closeModal(data.data)"
                [disabled]="loading">{{'Confirm Background Color' | translate}}</button>
        </div>
        <br />
    </div>
</form>